import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import kiosksStore from '../../store/kiosksStore';
import { AVAILABILITY_OPTIONS, STATUS_FILTER } from '~/constants/main';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { history } from '~/services/history';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { SearchInput } from '~/view/components/Controls/Inputs';
import LazyBranchesPicker from '~/view/components/Controls/Pickers/LazyBranchesPicker/LazyBranchesPicker';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';
import { appStore } from '~/mobx/appStore';

const KiosksHeader: FC = observer((): JSX.Element => {
  const selectedBranchOption = kiosksStore.filters.branchOption ? [kiosksStore.filters.branchOption] : undefined;
  const selectedStatusOption = kiosksStore.filters.statusOption ? [kiosksStore.filters.statusOption] : undefined;

  const statusOptions = useMemo((): IPickerOption[] => {
    return [
      { label: localeStore.t(STATUS_FILTER.ACTIVE), value: 1 },
      { label: localeStore.t(STATUS_FILTER.INACTIVE), value: 0 },
      { label: localeStore.t(AVAILABILITY_OPTIONS.DELETED), value: AVAILABILITY_OPTIONS.DELETED },
    ];
  }, []);

  const handleSearchChange = (value: string | undefined) => {
    kiosksStore.changeFilters({ search: value });
  };

  const handleBranchChange = (options: IPickerOption[]) => {
    const branchOption = options?.[0];
    kiosksStore.changeFilters({ branchOption });
  };

  const handleStatusChange = (options: IPickerOption[]) => {
    const statusOption = options?.[0];
    kiosksStore.changeFilters({ statusOption });
  };

  const handleCreateClick = () => {
    history.push(SCREENS.SETTINGS_DEVICES_KIOSKS_CREATE());
  };

  return (
    <div className="kiosks-header mr-4">
      <div className="d-flex gap-10">
        <SearchInput value={kiosksStore.filters.search} onChangeValue={handleSearchChange} contentClassName="kiosks-header__search" />

        <LazyBranchesPicker selectedOptions={selectedBranchOption} onSelect={handleBranchChange} />

        <Picker
          options={statusOptions}
          selectedOptions={selectedStatusOption}
          onSelect={handleStatusChange}
          placeholder={localeStore.t('select_status')}
        />
      </div>

      <Button disabled={!appStore.settings?.on_kiosk} title={localeStore.t('create_new_kiosk')} onClick={handleCreateClick} />
    </div>
  );
});

export default KiosksHeader;
